// modules
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { DxDataGridModule, DxSelectBoxModule, DxTextBoxModule } from 'devextreme-angular';
import { NgProgressModule, NgProgressInterceptor } from 'ngx-progressbar';

// components
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { LoginSSOComponent } from './login/login-sso.component';
import { InvalidPageComponent } from './layout/invalid-page.component';
import { UnauthorizedComponent } from './layout/unauthorized.component';
import { ModalComponent } from './shared/modal/modal.component';
import { HeaderComponent } from './layout/header.component';
import { FooterComponent } from './layout/footer.component';
import { MainComponent } from './layout/main.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { RecurrentTourComponent } from './recurrence/recurrent-tour.component';
import { RecurrentTourListComponent } from './recurrence/recurrent-tour-list.component';
import { RecurrentTourFormComponent } from './recurrence/recurrent-tour-form.component';
import { RecurrentOrderFormComponent } from './recurrence/recurrent-order-form.component';
import { RecurrentOrderItemFormComponent } from './recurrence/recurrent-orderitem-form.component';
import { RecurrentPatternComponent } from './recurrence/recurrent-pattern.component';
import { RecurrentLoadingFormComponent } from './recurrence/recurrent-loading-form.component';
import { RecurrentLoadingItemFormComponent } from './recurrence/recurrent-loadingitem-form.component';

// directives
import { DatetimePickerDirective } from './shared/directives/datetime-picker.directive';
import { NumberInputDirective } from './shared/directives/number-input.directive';
import { FlagCheckboxDirective } from './shared/directives/flag-checkbox.directive';

// services
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './core/auth-interceptor.service';
import { AuthService } from './core/auth.service';
import { DataService } from './core/data.service';
import { ModalService } from './shared/modal/modal.service';
import { SchedulerOrderService } from './core/scheduler-order.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoginSSOComponent,
    UnauthorizedComponent,
    InvalidPageComponent,
    ModalComponent,
    HeaderComponent,
    FooterComponent,
    MainComponent,
    RecurrentTourComponent,
    RecurrentTourListComponent,
    RecurrentTourFormComponent,
    RecurrentOrderFormComponent,
    RecurrentOrderItemFormComponent,
    RecurrentPatternComponent,
    RecurrentLoadingFormComponent,
    RecurrentLoadingItemFormComponent,
    ScheduleComponent,
    DatetimePickerDirective,
    NumberInputDirective,
    FlagCheckboxDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    SimpleNotificationsModule.forRoot(),
    DxDataGridModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    NgProgressModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    AuthService,
    DataService,
    ModalService,
    SchedulerOrderService,
    { provide: HTTP_INTERCEPTORS, useClass: NgProgressInterceptor, multi: true }
  ],
  entryComponents: [
    ModalComponent,
    RecurrentOrderItemFormComponent,
    RecurrentLoadingFormComponent,
    RecurrentLoadingItemFormComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts